export const CHECKOUT_STATE_ADVANCE = 'CHECKOUT_STATE_ADVANCE';
export const CHECKOUT_STATE_CHANGE = 'CHECKOUT_STATE_CHANGE';
export const CHECKOUT_SECTIONS = {
    login: 'login',
    address: 'address',
    orderSummary: 'payments',
    payments: 'payments'
};
export function checkoutStateAdvanceAction() {
    return { type: CHECKOUT_STATE_ADVANCE };
}
export function checkoutStateChangeAction(visualState, override) {
    return { type: CHECKOUT_STATE_CHANGE, visualState, override };
}
